import { render, staticRenderFns } from "./DoctorLayout.vue?vue&type=template&id=667e45cc&scoped=true"
import script from "./DoctorLayout.vue?vue&type=script&lang=js"
export * from "./DoctorLayout.vue?vue&type=script&lang=js"
import style0 from "./DoctorLayout.vue?vue&type=style&index=0&id=667e45cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667e45cc",
  null
  
)

export default component.exports